


document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
  

  var flkty = new Flickity( '.product-gallery__main', {
    // options
    });

    var flktyT = new Flickity( '.product-gallery__thumbnails', {
    asNavFor: '.product-gallery__main',
    contain: true,
    pageDots: false
    });

    // --------------------------------------------------
    // UNIVERSAL QUANTITY CONTROLS (FINAL VERSION)
    // --------------------------------------------------
    console.log('custom code run')
    $(document).on('click', '[data-update-quantity="plus"]', function () {
      console.log('plus ty')
      const $input = $(this).closest('.quantity-wrapper').find('.quantity-input');
      const max = parseInt($input.attr('max')) || 9999;
      let current = parseInt($input.val()) || 1;
      const min = parseInt($input.attr('min')) || 1;
      if ((current + 1) > min ) {
        const $minEl = $(this).closest('.quantity-wrapper').find('.quantity-minus');
        $minEl.removeAttr('disabled');
      }
      if ((current + 1) >= max) {
         $(this).attr("disabled", "disabled");
      }
      if (current < max) $input.val(current + 1).trigger('change');
    });

    $(document).on('click', '[data-update-quantity="minus"]', function () {
      const $input = $(this).closest('.quantity-wrapper').find('.quantity-input');
      const min = parseInt($input.attr('min')) || 1;
      const max = parseInt($input.attr('max')) || 9999;
      let current = parseInt($input.val()) || 1;
      
      if ((current - 1) <= min ) {
        $(this).attr("disabled", "disabled");
      }
      if ((current - 1) < max ) {
        const $maxEl = $(this).closest('.quantity-wrapper').find('.quantity-plus');
        $maxEl.removeAttr('disabled');
      }
      if (current > min) $input.val(current - 1).trigger('change');
    });

    $(document).on('change', '.quantity-input', function () {
      const qty = parseInt($(this).val()) || 1;
      const lineID =
        $(this).data('line-id') ||
        $(this).closest('[data-line-item]').data('line-item');

      if (!lineID) return;
      console.log('qty changed', qty)
      $.post('/cart/change.js',
        { line: lineID, quantity: qty },
        () => {
          if (window.PXUTheme.jsAjaxCart) window.PXUTheme.jsAjaxCart.updateView();
          if (window.PXUTheme.jsCart) window.PXUTheme.jsCart.updateView();
        }
      );
    });
});